import React, { useState, useEffect } from 'react';
import useAxiosPrivate from "../hooks/useAxiosPrivate"
import UpArrow from "../icon/UpArrow"
import DownArrow from "../icon/DownArrow"
import CompanyPrice from '../CompanyPrice'

export const numberFormat = (value, condition) => {
    if (!value) {
        return "0"
    }
    if (condition) {
        return (Math.round(value / 1000)).toLocaleString('en-IN')
    }
    if (value) {
        return value.toLocaleString('en-IN', { minimumFractionDigits: 2 })
    }
}


export const getClassName = (index, data) => {
    if (index % 2 === 0) {
        if (data > 0) {
            return "PeerTabledataCenter SubHeader OddDiv Green"
        } else if (data < 0) {
            return "PeerTabledataCenter SubHeader OddDiv Red"
        } else {
            return "PeerTabledataCenter SubHeader OddDiv Black"
        }
    } else {
        if (data > 0) {
            return "PeerTabledataCenter SubHeader Green"
        } else if (data < 0) {
            return "PeerTabledataCenter SubHeader Red"
        } else {
            return "PeerTabledataCenter SubHeader Black"
        }
    }
}

function CompanyInvestorMobile(props) {
    window.scrollTo(0, 0)
    const [pageData, setpageData] = useState({ pageLoaded: false });
    const axiosPrivate = useAxiosPrivate();

    const companyDetails = async () => {
        setpageData({})
        let url = ""
        url = process.env.REACT_APP_BASE_URL + "/v1/gurus/" + props.companySymbol + "/current?access_token=" + process.env.REACT_APP_DATA_API_SECRET_KEY;
        const cdresponse = await axiosPrivate.get(url);
        if (cdresponse.data.status === "Not Found") {
            setpageData({ dataNotFound: true, pageLoaded: true })
            return
        }
        localStorage.setItem("TableData", JSON.stringify(cdresponse.data));
        document.title = cdresponse.data.company_name + " : Superinvestor ownership";
        setpageData(cdresponse.data)

    }

    const getUrl = (url) => {
        return "/Investor/" + url
    }


    const SortIndicator = (indicator) => {
        const sortData = JSON.parse(localStorage.getItem('SortData'))
        const SortDataItem = localStorage.getItem('SortDataItem')
        if (indicator === SortDataItem) {
            if (sortData["pointer"]) {
                return [true, true]
            } else {
                return [true, false]
            }
        }
        return [false, false]
    }

    const showSorted = (pointer) => {
        const sortData = JSON.parse(localStorage.getItem('SortData'))
        if (sortData !== null) {
            if (Object.keys(sortData).includes('pointer')) {
                if (sortData["pointer"]) {
                    localStorage.setItem("SortData", JSON.stringify({ pointer: false }));
                    localStorage.setItem("SortDataItem", pointer);
                } else {
                    localStorage.setItem("SortData", JSON.stringify({ pointer: true }));
                    localStorage.setItem("SortDataItem", pointer);
                }
            } else {
                localStorage.setItem("SortData", JSON.stringify({ pointer: true }));
                localStorage.setItem("SortDataItem", pointer);
            }
        } else {
            localStorage.setItem("SortData", JSON.stringify({ pointer: true }));
            localStorage.setItem("SortDataItem", pointer);
        }
        const finalSortData = JSON.parse(localStorage.getItem('SortData'))

        const itemsData = JSON.parse(localStorage.getItem('TableData'))
        let tempData = itemsData["rows"]
        if (finalSortData["pointer"]) {
            if (['sector', 'industry', 'activity'].includes(pointer[0])) {
                tempData.sort(dynamicSortAscendingString(pointer));
            } else {
                tempData.sort(dynamicSortAscending(pointer));
            }
        } else {
            if (['sector', 'industry', 'activity'].includes(pointer[0])) {
                tempData.sort(dynamicSortDescendingString(pointer));
            } else {
                tempData.sort(dynamicSortDescending(pointer));
            }
        }
        let finalData = itemsData
        finalData["rows"] = tempData
        setpageData(finalData)
    }

    function forceDefault(data) {
        if (data === "-") {
            return 0
        } else {
            return data
        }
    }

    function dynamicSortDescending(property) {
        var sortOrder = 1;
        if (property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a, b) {
            /* next line works with strings and numbers, 
             * and you may want to customize it to your needs
             */
            var result = (parseFloat(forceDefault(a[property])) > parseFloat(forceDefault(b[property]))) ? -1 : (parseFloat(forceDefault(a[property])) < parseFloat(forceDefault(b[property]))) ? 1 : 0;
            return result * sortOrder;
        }
    }


    function dynamicSortAscending(property) {
        var sortOrder = 1;
        if (property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a, b) {
            /* next line works with strings and numbers, 
             * and you may want to customize it to your needs
             */
            var result = (parseFloat(forceDefault(a[property])) < parseFloat(forceDefault(b[property]))) ? -1 : (parseFloat(forceDefault(a[property])) > parseFloat(forceDefault(b[property]))) ? 1 : 0;
            return result * sortOrder;
        }
    }


    function dynamicSortDescendingString(property) {
        console.log("inside sort")
        var sortOrder = 1;
        if (property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a, b) {
            /* next line works with strings and numbers, 
             * and you may want to customize it to your needs
             */
            var result = (String(a[property]) > String(b[property])) ? -1 : (String(a[property]) < String(b[property])) ? 1 : 0;
            return result * sortOrder;
        }
    }


    function dynamicSortAscendingString(property) {
        var sortOrder = 1;
        if (property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a, b) {
            /* next line works with strings and numbers, 
             * and you may want to customize it to your needs
             */
            var result = (String(a[property]) < String(b[property])) ? -1 : (String(a[property]) > String(b[property])) ? 1 : 0;
            return result * sortOrder;
        }
    }

    useEffect(() => {
        companyDetails()
    }, [])

    return (
        <div id="CompanyInvestorMobile">
            <section className="optionsFinData">
                <div className="leftAlign growthCompanyName" style={{ paddingLeft: "0px", fontWeight: "600" }}>
                    <CompanyPrice companySymbol={props.companySymbol} name={pageData.company_name} source="mobile"/>
                </div>
            </section>
            <div style={{ overflow: "auto", backgroundColor: "white", borderRadius: "10px" }}>
                <table className="PeersTable finData" style={{ width: "100%", fontSize: "9px" }}>
                    <thead style={{ backgroundColor: "white", zIndex: "20" }}>
                        <tr>
                            <th className="PeerColumnHeading" style={{ whiteSpace: "nowrap" }}><div>Name</div></th>
                            <th className="columnHeading" style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center", fontWeight: "500" }}>
                                <div style={{ cursor: "pointer", color: "blue", display: "flex", justifyContent: "center", paddingTop: "5px" }} onClick={() => showSorted(['pct_of_ownership'])}>
                                    <div>
                                        % of ownership
                                    </div>
                                    <div style={{ paddingTop: "5px" }}>
                                        {SortIndicator("pct_of_ownership")[0] ? <div>{SortIndicator("pct_of_ownership")[1] ? <DownArrow /> : < UpArrow />}</div> : <div style={{ minHeight: "25px" }}>&nbsp;</div>}
                                    </div>
                                </div>
                            </th>
                            <th className="columnHeading" style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center", fontWeight: "500" }}>
                                <div style={{ cursor: "pointer", color: "blue", display: "flex", justifyContent: "center", paddingTop: "5px" }} onClick={() => showSorted(['pct_change'])}>
                                    <div>
                                        % change
                                    </div>
                                    <div style={{ paddingTop: "5px" }}>
                                        {SortIndicator("pct_change")[0] ? <div>{SortIndicator("pct_change")[1] ? <DownArrow /> : < UpArrow />}</div> : <div style={{ minHeight: "25px" }}>&nbsp;</div>}
                                    </div>
                                </div>

                            </th>
                            <th className="columnHeading" style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center", fontWeight: "500" }}>
                                <div style={{ cursor: "pointer", color: "blue", display: "flex", justifyContent: "center", paddingTop: "5px" }} onClick={() => showSorted(['number_of_shares'])}>
                                    <div>
                                        Number of shares (k)
                                    </div>
                                    <div style={{ paddingTop: "5px" }}>
                                        {SortIndicator("number_of_shares")[0] ? <div>{SortIndicator("number_of_shares")[1] ? <DownArrow /> : < UpArrow />}</div> : <div style={{ minHeight: "25px" }}>&nbsp;</div>}
                                    </div>
                                </div>

                            </th>
                            <th className="columnHeading" style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center", fontWeight: "500" }}>
                                <div style={{ cursor: "pointer", color: "blue", display: "flex", justifyContent: "center", paddingTop: "5px" }} onClick={() => showSorted(['investment_value'])}>
                                    <div>
                                        Investment Value (cr)
                                    </div>
                                    <div style={{ paddingTop: "5px" }}>
                                        {SortIndicator("investment_value")[0] ? <div>{SortIndicator("investment_value")[1] ? <DownArrow /> : < UpArrow />}</div> : <div style={{ minHeight: "25px" }}>&nbsp;</div>}
                                    </div>
                                </div>

                            </th>

                        </tr>
                    </thead>
                    <tbody>
                        {pageData.rows?.map((dataKey, index) => (
                            <tr>
                                <td className={index % 2 === 0 ? "PeerTabledataLeft SubHeader OddDiv" : "PeerTabledataLeft SubHeader"}><div className="StockLink"><a href={getUrl(dataKey.shareholder_id)} target="_blank" style={{ textDecoration: "None" }}>{dataKey.shareholder_name}</a></div></td>
                                <td className={index % 2 === 0 ? "PeerTabledataCenter SubHeader OddDiv" : "PeerTabledataCenter SubHeader"} style={{ minWidth: "80px" }}>{numberFormat(dataKey.pct_of_ownership, false)}</td>
                                <td className={getClassName(index, dataKey.pct_change)} style={{ minWidth: "80px" }}>{numberFormat(dataKey.pct_change, false)} %</td>
                                <td className={index % 2 === 0 ? "PeerTabledataCenter SubHeader OddDiv" : "PeerTabledataCenter SubHeader"} style={{ minWidth: "80px" }}>{Math.round(dataKey.number_of_shares).toLocaleString('en-IN')}</td>
                                <td className={index % 2 === 0 ? "PeerTabledataCenter SubHeader OddDiv" : "PeerTabledataCenter SubHeader"} style={{ whiteSpace: "nowrap" }}>{Math.round(dataKey.investment_value).toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>

                            </tr>
                        ))}
                        {(pageData.dataNotFound === true || pageData.rows?.length === 0 || pageData.rows === undefined) && pageData.pageLoaded &&
                            <tr>
                                <td>Data not found</td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
}
export default CompanyInvestorMobile;